<script>
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import config from "../stores/config";
  import * as ls from "local-storage";
  import t from "../utils/t";

  export let _id;
  export let content;
  export let addedBy;
  // export let userID;
  export let addedOn;

  const dispatch = createEventDispatcher();

  const handleDelete = () => {
    let confirmDelete = confirm(
      `❌ ${t({
        en: "Do you wish to delete this report?",
        fr: "Voulez-vous supprimer cette note?",
      })}`
    );

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/reports/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  onMount(() => {});
</script>

<div
  class="px-4 py-4 rounded-md shadow-sm bg-gradient-to-r from-gray-50 to-gray-100 flex flex-col justify-between"
>
  <div class="">
    <h1
      class="text-xs tracking-wider uppercase text-green-600 flex items-center mb-3"
    >
      <ion-icon name="document-text" class="text-2xl mr-2" />
      — Added by {addedBy}
    </h1>
    <h1
      class="text-xs tracking-wider uppercase text-gray-600 flex items-center mb-3"
    >
      <ion-icon name="time" class="text-2xl mr-2" />
      — On {new Date(addedOn).toDateString()} at {new Date(
        addedOn
      ).toLocaleTimeString()}
    </h1>

    {content}
  </div>

  <div class="mt-4">
    <button
      style="width: 100%;"
      on:click={handleDelete}
      class="shadow-sm flex items-center justify-center rounded-lg py-1 px-3 bg-gradient-to-r from-red-200 to-red-100 text-red-400"
    >
      <ion-icon name="trash" class="text-2xl text-red-500 mr-2" />
      Delete the Note
    </button>
  </div>
</div>
